import React from 'react'
import { Container, Typography, List, ListItem, ListItemText, Link } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const PrivacyPolicyRu = () => {
  const theme = useTheme()

  return (
    <Container
      maxWidth='md'
      sx={{
        py: 4,
        color: theme.palette.primary.contrastText,
        '& p, & ul': { textIndent: '2em' }
      }}
    >
      <Typography variant='h4' sx={{ mt: 0, mb: 8, textAlign: 'center' }}>
        Политика обработки персональных данных
      </Typography>
      <Typography paragraph>
        Настоящая Политика обработки персональных данных Общества с ограниченной ответственностью «СИЛК» (ОГРН
        1197746542542, ИНН 7734429036, КПП 772101001, юр. адрес: 109378, город Москва, вн.тер.г. муниципальный округ
        Кузьминки, пр-кт Волгоградский, д. 169, кв. 49) (далее — Компания, Оператор обработки персональных данных)
        разработана для сайта Компании в сети Интернет по адресу:{' '}
        <Link href='https://gosilk.ru' target='_blank'>
          {'https://gosilk.ru'}
        </Link>
        , (далее — Политика) и действует в отношении всей информации, включая персональные данные Пользователей сайта
        согласно положениям Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — ФЗ № 152) и
        применимыми международными стандартами в области обработки и защиты персональных данных (далее — Персональная
        информация), которую Компания получает о Пользователе во время использования им Сайта, а также обеспечивает ее
        обработку.
      </Typography>
      <Typography paragraph>
        Использование сервисов Сайта означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в
        ней условиями обработки его персональной информации; в случае несогласия с этими условиями Пользователь должен
        воздержаться от использования сервисов.
      </Typography>
      <Typography paragraph>
        Доступ к персональным данным Пользователей имеют только те сотрудники, в чьи прямые обязанности входит работа с
        персональными данными Пользователей. Сотрудники обладают нужными профессиональными навыками по защите данных и
        обращаются к ним только когда это необходимо.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        1. Общие положения
      </Typography>
      <Typography paragraph>
        1.1. В рамках настоящей Политики под персональной информацией Пользователя понимаются:
      </Typography>
      <Typography paragraph>
        1.1.1. Персональная информация, которую Пользователь предоставляет о себе самостоятельно для регистрации
        (создании учетной записи) или в процессе использования Сервисов, включая персональные данные Пользователя.
        Обязательная для предоставления Сервисов информация помечена специальным образом. Персональная информация
        Пользователя, обработку которых осуществляет Компания при обработке заявок:
      </Typography>
      <List sx={{ p: 0 }}>
        <ListItem disableGutters>
          <ListItemText primary='- мобильный телефон Пользователя;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- паспортные данные Пользователя;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- адрес электронной почты Пользователя;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- данные из социальных сетей пользователя;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- банковские реквизиты Пользователя;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- для артистов и их представителей: сценическое имя, творческий псевдоним артиста, текстовые, графические, фотографические или видео элементы записи исполнения или аудиовизуального произведения; обложки, слова, видео, названия произведений (музыкальные произведения с текстом или без текста), даты опубликования произведений, биографии, видео и фотографии исполнителей, ФИО физического лица или наименование юридического лица, обладающего правами на произведения, аранжировки и/или иллюстрации альбома;' />
        </ListItem>

        <ListItem disableGutters>
          <ListItemText primary='- метаданные, необходимые для идентификации произведений, зафиксированных в записях, в частности имена авторов, исполнителей, коды ISWC, ISRC, UPC и т.д.;' />
        </ListItem>
        <ListItem disableGutters>
          <ListItemText primary='- демографические данные о Пользователях (например, возраст, пол, место жительства).' />
        </ListItem>
      </List>
      <Typography paragraph>
        1.1.2. Данные, которые автоматически передаются сервисам Сайта в процессе их использования с помощью
        установленного на устройстве Пользователя программного обеспечения, в том числе IP-адрес, данные файлов cookie,
        информация о браузере Пользователя (или иной программе, с помощью которой осуществляется доступ к сервисам),
        технические характеристики оборудования и программного обеспечения, используемых Пользователем, дата и время
        доступа к сервисам, адреса запрашиваемых страниц и иная подобная информация.
      </Typography>
      <Typography paragraph>
        1.2. Настоящая Политика обработки персональных данных применяется только к Сайту{' '}
        <Link href='https://gosilk.ru' target='_blank'>
          {'https://gosilk.ru'}
        </Link>{' '}
        и отношениям между Компанией и Пользователями. Сайт{' '}
        <Link href='https://gosilk.ru' target='_blank'>
          {'https://gosilk.ru'}
        </Link>{' '}
        не контролирует и не несет ответственности за сайты третьих лиц, на которые Пользователь может перейти по
        ссылкам, доступным на Сайте{' '}
        <Link href='https://gosilk.ru' target='_blank'>
          {'https://gosilk.ru'}
        </Link>
        .
      </Typography>
      <Typography paragraph>
        1.3. Перед началом использования Сайта и прохождения процедуры регистрации, Пользователь выражает согласие на
        обработку персональных данных, указанных в п. 1.1.1 настоящей Политики.
      </Typography>
      <Typography paragraph>
        1.4. При предоставлении данных в них могут содержаться данные не только Пользователя, но и третьих лиц,
        полученные Пользователем. Настоящим Пользователь подтверждает, гарантирует и заверяет, что он получил согласие
        всех лиц на передачу Компании Персональной информации, полученной Компанией от Пользователя, поручает Компании
        обрабатывать такие данные в соответствии с настоящим Соглашением, и обязуется в случае запроса Компании передать
        явно выраженное письменное подтверждение такого согласия, а также возместить все и любые убытки, возникшие в
        связи с нарушением такого обязательства, заверения и/или гарантии.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        2. Принципы обработки персональных данных
      </Typography>
      <Typography paragraph>
        2.1. Обработка персональных данных Пользователей осуществляется на законной и справедливой основе в соответствии
        с определенными целями сбора персональных данных.
      </Typography>
      <Typography paragraph>
        2.2. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.
      </Typography>
      <Typography paragraph>
        2.3. Не допускается объединение баз данных, содержащих персональные данные, обработка которых осуществляется в
        целях, несовместимых между собой.
      </Typography>
      <Typography paragraph>
        2.4. Пользователь гарантирует, что предоставляет достоверные и актуальные персональные данные. В случае
        необходимости актуализации персональных данных, Пользователь может обратиться с запросом по электронному адресу
        Компании: report@gosilk.ru. Компания вносит изменения в течение 30 (Тридцати) дней с даты обращения
        Пользователя.
      </Typography>
      <Typography paragraph>
        2.5. При обработке персональных данных должны быть обеспечены точность персональных данных, их достаточность, а
        в необходимых случаях и актуальность по отношению к целям обработки персональных данных. Компании должна
        принимать необходимые меры, либо обеспечивать их принятие по удалению или уточнению неполных или неточных
        данных.
      </Typography>
      <Typography paragraph>
        2.6. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта персональных данных,
        не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не
        установлен федеральным законом, договором, стороной которого, выгодоприобретателем или поручителем, по которому
        является субъект персональных данных. Обрабатываемые персональные данные подлежат уничтожению либо обезличиванию
        по достижении целей обработки или в случае утраты необходимости в достижении этих целей, если иное не
        предусмотрено федеральным законом.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        3. Цели сбора и обработки
      </Typography>
      <Typography paragraph>
        3.1. Компания собирает, обрабатывает и хранит только те персональные данные, которые необходимы для
        предоставления сервисов или исполнения соглашений и договоров с Пользователем, а также в соответствии с
        требованиями законодательства Российской Федерации.
      </Typography>
      <Typography paragraph>
        3.2. В случае получения уведомления от Пользователя об отзыве согласия на обработку персональных данных, Сайт
        прекращает обработку персональных данных Пользователя в срок, не превышающий 30 (Тридцати) рабочих дней с
        момента получения.
      </Typography>
      <Typography paragraph>
        3.3. Уведомление об отзыве согласия на обработку персональных данных направляется на адрес электронной почты:
        report@gosilk.ru, а также путем письменного обращения по юридическому адресу: 109378, город Москва, вн.тер.г.
        муниципальный округ Кузьминки, пр-кт Волгоградский, д. 169, кв. 49.
      </Typography>
      <Typography paragraph>3.4. Персональную информацию Пользователя Сайт обрабатывает в следующих целях:</Typography>
      <Typography paragraph>
        3.4.1. Получение и рассмотрение заявок на сотрудничество с Компанией через форму на Сайте, предоставление
        Пользователю доступа к Сайту и/или Сервисам;
      </Typography>
      <Typography paragraph>
        3.4.2. Создание учетной записи Пользователя (личного кабинета правообладателя) для доступа к персонализированным
        сервисам Компании, а также возможность использовать её функциональные возможности, в том числе передача объектов
        исключительной собственности третьим лицам. Идентификация Пользователя, зарегистрированного на Сайте;
      </Typography>
      <Typography paragraph>
        3.4.3. Заключение и/или исполнение договоров, заключенных между Пользователем и Компанией;
      </Typography>
      <Typography paragraph>
        3.4.4. Предоставление Пользователю доступа к персонализированным ресурсам Сайта;
      </Typography>
      <Typography paragraph>
        3.4.5. Установление с Пользователем обратной связи, включая направление уведомлений, запросов, касающихся
        использования Сайта, оказания услуг, обработку запросов и заявок от Пользователя;
      </Typography>
      <Typography paragraph>
        3.4.6. Осуществление связи с Пользователем для направления уведомлений, информации об исполнении обязательств,
        запросов, информации и требований, относящейся к работе Сайтов и Сервисов, исполнения договорных обязательств
        между Компанией и Пользователем;
      </Typography>
      <Typography paragraph>3.4.7. Повышение удобства использования Сайта и Сервисов;</Typography>
      <Typography paragraph>3.4.8. Предложение новых решений, бизнес-стратегий и договорных обязательств;</Typography>
      <Typography paragraph>3.4.9. Защита прав Пользователя и прав Компании;</Typography>
      <Typography paragraph>
        3.4.10. Сбор, обработка и представление статистических данных, отчетов и других исследований;
      </Typography>
      <Typography paragraph>
        3.4.11. Организация приема и передачи платежей, осуществления оплаты по договорным обязательствам;
      </Typography>
      <Typography paragraph>
        3.4.12. Распространение или обеспечение возможности распространения результатов интеллектуальной деятельности;
      </Typography>
      <Typography paragraph>
        3.4.13. Подтверждение достоверности и полноты персональных данных, предоставленных Пользователем;
      </Typography>
      <Typography paragraph>
        3.4.14. Предоставление Пользователю эффективной клиентской и технической поддержки при возникновении проблем,
        связанных с использованием Сайта;
      </Typography>
      <Typography paragraph>
        3.4.15. Осуществление рекламной деятельности с согласия Пользователя, в том числе информирование Пользователя о
        проводимых мероприятиях и акциях в соответствии с ч. 1 ст. 18 Федерального закона «О рекламе»;
      </Typography>
      <Typography paragraph>
        3.4.16. Предоставление иной информации, связанную с отношениями, возникшими между Компанией и Пользователем.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        4. Условия обработки персональной информации пользователя и её передачи третьим лицам
      </Typography>
      <Typography paragraph>
        4.1. Компания обрабатывает персональную информацию Пользователей в соответствии с внутренними регламентами
        конкретных сервисов.
      </Typography>
      <Typography paragraph>
        4.2. Компания передаёт информацию третьим лицам для обеспечения возможности исполнения договорных отношений
        между Компанией и Пользователем, в частности для обеспечения распространения результатов интеллектуальной
        деятельности, предоставляемых Пользователем, а также сборов вознаграждения за такие результаты, а также для
        передачи рекламных сообщений о предложениях третьих лиц Пользователю о возможности распространения результатов
        интеллектуальной деятельности. При использовании отдельных сервисов, Пользователь соглашается с тем, что
        определенная часть его персональной информации становится общедоступной.
      </Typography>
      <Typography paragraph>
        4.3. Компания осуществляет передачу персональных данных ООО «Яндекс», ООО «Яндекс.Облако», на серверах которых
        Компания хранит персональные данные, и настоящим Пользователь соглашается с такой передачей и хранением, в том
        числе трансграничным, если это допустимо по соглашению с Пользователем, а также Пользователь соглашается с
        передачей персональных данных третьим лицам, получающим права или возможность использования результатов
        интеллектуальной деятельности на основе договорных отношений с Пользователем или Компанией, что в том числе
        включает право на трансграничную передачу персональных данных Пользователя без каких либо ограничений для
        исполнения договорных обязательств с Пользователем (в частности, когда пользователь выражает согласие на
        передачу его результатов интеллектуальной деятельности за границу).
      </Typography>
      <Typography paragraph>
        4.4. Обработка персональных данных Пользователя осуществляется без ограничения срока следующими способами: сбор,
        запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование,
        передача (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение
        персональных данных, в том числе в информационных системах персональных данных с использованием средств
        автоматизации или без использования таких средств. Обработка персональных данных Пользователей осуществляется в
        соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».
      </Typography>
      <Typography paragraph>
        4.5. При утрате или разглашении персональных данных Компания информирует Пользователя об утрате или разглашении
        персональных данных.
      </Typography>
      <Typography paragraph>
        4.6. Компания принимает необходимые организационные и технические меры для защиты персональной информации от
        неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а
        также от иных неправомерных действий третьих лиц.
      </Typography>
      <Typography paragraph>
        4.7. Компания принимает все необходимые меры по предотвращению убытков или иных отрицательных последствий,
        вызванных утратой или разглашением персональных данных Пользователя, однако ответственность Компании ограничена
        установленными законодательством штрафами и возмещение убытков в рамках гражданского судопроизводства не
        предполагается. Компания не несёт ответственность перед Пользователем за использование и обработку Персональных
        данных в рамках гражданских отношений.
      </Typography>
      <Typography variant='h6' sx={{ mt: 10, mb: 4, textAlign: 'center' }}>
        5. Изменение Политики обработки персональных данных
      </Typography>
      <Typography paragraph>
        5.1. Компания имеет право вносить изменения в настоящую Политику обработки персональных данных. При внесении
        изменений в актуальной редакции указывается дата последнего обновления. Новая редакция Политики вступает в силу
        момента ее размещения, если иное не предусмотрено новой редакцией Политики. Действующая редакция Политики
        обработки персональных данных доступа для Пользователя на сайте Компании в сети Интернет по адресу:{' '}
        <Link href='https://gosilk.ru/privacy-policy' target='_blank'>
          {'https://gosilk.ru/privacy-policy'}
        </Link>
        .
      </Typography>
      <Typography paragraph>
        5.2. При возникновении вопросов или предложений по настоящей Политике Пользователь может обратиться с запросом
        по электронному адресу Компании:{' '}
        <Link href='mailto:report@gosilk.ru' target='_blank'>
          {'report@gosilk.ru'}
        </Link>
        .
      </Typography>
    </Container>
  )
}

export default PrivacyPolicyRu
